import { z } from 'zod';

import {
  AddTemplateFormSchema,
  grantTemplateSignatoriesRefine,
  stepOneShape,
  stepOneSuperRefine,
  stepThreeShape,
  stepThreeSuperRefine,
  stepTwoSchema,
  stepTwoShape,
  stepTwoSuperRefine,
} from './add-template.validation';

export const updateStepOneSchema = stepOneShape.partial().superRefine(stepOneSuperRefine);
export const updateStepTwoSchema = stepTwoShape.partial().superRefine(stepTwoSuperRefine);
export const updateStepThreeSchema = stepThreeShape.partial().superRefine(stepThreeSuperRefine);

export const updateTemplateFormSchema = z.object({
  stepOne: updateStepOneSchema,
  stepTwo: updateStepTwoSchema,
  stepThree: updateStepThreeSchema,
});

export type UpdateTemplateFormSchema = z.infer<typeof updateTemplateFormSchema>;

export const getUpdateTemplateSchemaForStep = (step: number) => {
  if (step === 4) {
    return updateTemplateFormSchema.superRefine(grantTemplateSignatoriesRefine);
  }
  if (step === 2) {
    return z
      .object({
        stepOne: z.any(),
        stepTwo: stepTwoSchema,
        stepThree: z.any(),
      })
      .superRefine(grantTemplateSignatoriesRefine);
  }
  return z.object({
    stepOne: step === 1 ? updateStepOneSchema : z.any(),
    stepTwo: step === 2 ? updateStepTwoSchema : z.any(),
    stepThree: step === 3 ? updateStepThreeSchema : z.any(),
  });
};

export type TemplateFormSchema = AddTemplateFormSchema | UpdateTemplateFormSchema;
